import { render, staticRenderFns } from "./AppDialogContainer.vue?vue&type=template&id=63d234c1"
import script from "./AppDialogContainer.vue?vue&type=script&lang=ts"
export * from "./AppDialogContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports